import React from "react";
import "./sidebar.scss";
import mapMarker from "../../../media/map-marker.svg";
import useTrackWebContext from "../../../hooks/useTrackWebContext";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({onAddCollaborator}) => {
  const { infoCommerce } = useTrackWebContext();
  const location = useLocation();

  return (
    <>
      <aside
        className="
          w-full rounded-[3px] shrink-0 relative my-10 px-5 pb-4 bg-[#fff]
          md:shadow-md md:px-[30px] md:pt-[25px] md:pb-[16px] md:mt-0
          lg:w-[360px] lg:mb-[18px]
        "
      >
        <div className="text-center">
          <img
            src={infoCommerce?.logo}
            className="inline-block relative my-3"
            alt="Imagen de la marca"
          />
          <div className="user-fullName m-3">
            <h2 className="font-bold text-2xl text-gray-900">
              {infoCommerce?.nombre_marca}
            </h2>
            <p className="font-normal text-[15px] text-gray-500">
              {infoCommerce?.rubro}
            </p>
          </div>
          {infoCommerce?.rol === "comercio" && (
            <div className="user-details my-4">
              <p className="text-[15px] text-gray-500">N° de Establecimiento</p>
              <p className="text-2xl text-gray-900">
                <b>{infoCommerce?.nro_comercio}</b>
              </p>
              <div className="user-location my-4 flex items-center justify-center text-center text-[15px] text-gray-500">
                <img className="mr-2 w-2" src={mapMarker} alt="marcador" />
                <span className="">{infoCommerce?.id_provincia}, Argentina</span>
              </div>
            </div>
          )}
          <div className="block my-4 p-4 rounded-lg border border-clvblue discount-block">
            <p className="font-bold text-base text-gray-900 border-b border-gray-100 pb-2">
              Promoción habitual
            </p>
            <h2 className="flex items-center justify-center font-bold text-clvblue py-2">
              <span className="text-4xl">{infoCommerce?.descuento}%</span>
              <span className="text-2xl pl-2">de descuento</span>
            </h2>
            <p className="text-[15px] text-gray-500">
              {infoCommerce?.tyc !== "NULL" ? infoCommerce?.tyc : ""}
            </p>
          </div>
          <div className="flex flex-col items-center py-4">
            {location.pathname === "/metrics" && (infoCommerce?.rol === "comercio" || infoCommerce?.rol === "colaborador") ? (
              <Link
                to="/"
                className="w-40 p-1 h-8 border border-clvblue font-bold text-sm text-clvblue rounded-full hover:bg-clvblue hover:border-none hover:text-gray-50 mb-2"
              >
                Registrar venta
              </Link>
            ) : (
              location.pathname !== "/metrics" && (
                <Link
                  to="/metrics"
                  className="w-40 p-1 h-8 border border-clvblue font-bold text-sm text-clvblue rounded-full hover:bg-clvblue hover:border-none hover:text-gray-50 mb-2"
                >
                  Ventas registradas
                </Link>
              )
            )}
            {infoCommerce?.rol === "comercio" && 
            <Link
              to="/collaborators"
              className="w-40 p-1 h-8 border border-clvblue font-bold text-sm text-clvblue rounded-full hover:bg-clvblue hover:border-none hover:text-gray-50 mb-2"
            >
              Añadir colaborador
            </Link>}
            <Link
              to="/edit-profile"
              className="w-40 p-1 h-8 border border-clvblue font-bold text-sm text-clvblue rounded-full hover:bg-clvblue hover:border-none hover:text-gray-50"
            >
              Editar perfil
            </Link>
            
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
